import { render } from "./message-overview.vue?vue&type=template&id=fe7b5644"
import script from "./message-overview.vue?vue&type=script&lang=js"
export * from "./message-overview.vue?vue&type=script&lang=js"

import exportComponent from "/usr/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__